<script type="text/ecmascript-6">
import { mapGetters } from 'vuex';
import Vue from 'vue'

import lottie from 'lottie-web';
import CryptoJS from 'crypto-js';
import Toasted from 'vue-toasted';

Vue.use(Toasted)
export default {
    name: 'user-subscription',



    metaInfo() {
        return {
            title: 'Subscribe',
            link: [
                { rel: 'apple-touch-icon', sizes: '57x57', href: '/fav/apple-icon-57x57.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '60x60', href: '/fav/apple-icon-60x60.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '72x72', href: '/fav/apple-icon-72x72.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '76x76', href: '/fav/apple-icon-76x76.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '114x114', href: '/fav/apple-icon-114x114.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '120x120', href: '/fav/apple-icon-120x120.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '144x144', href: '/fav/apple-icon-144x144.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '152x152', href: '/fav/apple-icon-152x152.png?v=0.1' },
                { rel: 'apple-touch-icon', sizes: '180x180', href: '/fav/apple-icon-180x180.png?v=0.1' },
                { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/fav/android-icon-192x192.png?v=0.1' },
                { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/fav/favicon-32x32.png?v=0.1' },
                { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/fav/favicon-96x96.png?v=0.1' },
                { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/fav/favicon-16x16.png?v=0.1' }
            ]
        }
    },

    /**
     * The component's data.
     */
    data: () => ({
        loading: true,
        playlist: [],
        images: [],
        amount: 1000,
        phone: '',
        otp: '',
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
        otpArr: [],
        premiumBenefits: [
            {
                title: 'Ad free music',
                image: '/benefits/ad-free.svg',
            },
            {
                title: 'High Audio Quality ',
                image: '/benefits/music-library.svg',
            },
            {
                title: 'Download & Listen Offline',
                image: '/benefits/download-cloud.svg',
            },
            {
                title: 'Visible Lyrics',
                image: '/benefits/music-note.svg',
            },
            {
                title: 'Offline Playlist Creation',
                image: '/benefits/playlist.svg',
            },

        ],

        show: false,
        token: document.head.querySelector('meta[name="csrf-token"]'),
        activePayment: 0,
        selectedPlanOptions: 0,
        isPaymentSuccess: false,
        paymentImages: [
            {
                name: 'applepay',
                image: '/payment/apple_icon.svg'
            },
            {
                name: 'mpt',
                image: '/payment/mpt_payment.svg',
            },
            {
                name: 'atom',

                image: '/payment/atom_payment.svg'

            },
            {
                name: 'kbzpay',

                image: '/payment/kbz_payment.svg',
            },
            {
                name: 'dinger_card',
                image: '/payment/visa_payment.svg',

            },
            {
                name: 'dinger_online',
                image: '/payment/wallet.svg',

            },
            {
                name: 'coin',
                image: '/payment/coin.svg',
            }
        ],

        // paymentOptions: [
        // {
        //         "id": 2,
        //         "order": 0,
        //         "name": "mpt",
        //         "label": "MPT",
        //         "is_auto_renewal": true,
        //         "premium_type": "subscription",
        //         "description": "MPT Payment",
        //         "plans": [
        //             {
        //                 "id": 5,
        //                 "label": "Daily",
        //                 "amount": 99,
        //                 "day": 1,
        //                 "custom_order": 2,
        //                 "apple_product_id": null,
        //                 "apple_price": null
        //             },
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     },
        //     {
        //         "id": 1,
        //         "order": 0,
        //         "name": "kbzpay",
        //         "label": "KBZ Pay",
        //         "is_auto_renewal": false,
        //         "premium_type": "one_time",
        //         "description": "KBZ Pay Payment",
        //         "plans": [
        //             {
        //                 "id": 5,
        //                 "label": "Daily",
        //                 "amount": 99,
        //                 "day": 1,
        //                 "custom_order": 2,
        //                 "apple_product_id": null,
        //                 "apple_price": null
        //             },
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     },
           
        //     {
        //         "id": 3,
        //         "order": 0,
        //         "name": "coin",
        //         "label": "Coin",
        //         "is_auto_renewal": false,
        //         "premium_type": "one_time",
        //         "description": "Melo coins",
        //         "plans": [
        //             {
        //                 "id": 5,
        //                 "label": "Daily",
        //                 "amount": 99,
        //                 "day": 1,
        //                 "custom_order": 2,
        //                 "apple_product_id": null,
        //                 "apple_price": null
        //             },
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             }
        //         ]
        //     },
        //     {
        //         "id": 4,
        //         "order": 0,
        //         "name": "applepay",
        //         "label": "In App Purchase",
        //         "is_auto_renewal": true,
        //         "premium_type": "subscription",
        //         "description": "Apple's in app purchase",
        //         "plans": [
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     },
        //     {
        //         "id": 5,
        //         "order": 0,
        //         "name": "dinger_card",
        //         "label": "Credit/Debit Cards",
        //         "is_auto_renewal": false,
        //         "premium_type": "one_time",
        //         "description": "VISA, PayPal, MasterCard",
        //         "plans": [
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     },
        //     {
        //         "id": 6,
        //         "order": 0,
        //         "name": "dinger_online",
        //         "label": "Wallet Payment",
        //         "is_auto_renewal": false,
        //         "premium_type": "one_time",
        //         "description": "AYA Pay, Wave Pay, One Pay, CB Pay, True Money...",
        //         "plans": [
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     },
        //     {
        //         "id": 7,
        //         "order": 0,
        //         "name": "atom",
        //         "label": "ATOM",
        //         "is_auto_renewal": true,
        //         "premium_type": "subscription",
        //         "description": "Atom Payment",
        //         "plans": [
        //             {
        //                 "id": 5,
        //                 "label": "Daily",
        //                 "amount": 99,
        //                 "day": 1,
        //                 "custom_order": 2,
        //                 "apple_product_id": null,
        //                 "apple_price": null
        //             },
        //             {
        //                 "id": 2,
        //                 "label": "Weekly",
        //                 "amount": 599,
        //                 "day": 7,
        //                 "custom_order": 3,
        //                 "apple_product_id": "com.melomm.melomusic.weekly",
        //                 "apple_price": "0.99"
        //             },
        //             {
        //                 "id": 1,
        //                 "label": "Monthly",
        //                 "amount": 1999,
        //                 "day": 30,
        //                 "custom_order": 4,
        //                 "apple_product_id": "com.melomm.melomusic.monthly",
        //                 "apple_price": "1.99"
        //             }
        //         ]
        //     }
        // ],
        planOptions: [
        ],
        isAtomPayment: false,
        atomPhoneNumber: null,
        showAtomOtpVerify: false,
        inputsLength: 6,
        phoneLastNumber: '',
        atomPaymentPending: false,
        showKBZQR: false,
        qrCode: "",
        atomClientTransactionId: null,
        isDisable: false,
        appleReceipt: ""

    }),

    inject: ['$validator'],


    /**
     * Computed these properties.
     */
    computed: {
        ...mapGetters({
            activeStep: 'getUserPaymentStep',
            payment: 'getUserPayment',
            user: 'getProfile',
            paymentOptions: 'getUserPaymentProviders'

        }),
        qrValue() {
            return `https://api.qrserver.com/v1/create-qr-code/?data=${this.qrCode}&amp;size=100x100`
        },
        paymentImageByName() {
            return (name) => {
                const imageObj = this.paymentImages.find(image => image.name === name);
                return imageObj ? imageObj.image : null;
            };
        }

    },


    /**
     * Created the component.
     */
    mounted() {
       


    },

    watch: {

        paymentOptions(newValue) {
            if (newValue.length > 0) {
                this.isDisable = false
            } else {
                this.isDisable = true
            }

        },


        // Watch for changes in activeStep and update URL query parameter
        activeStep(newStep) {
            this.updateQuery({ step: newStep });
        },
        // Watch for URL query changes and sync state
        '$route.query.step': {
            immediate: true,
            handler(newVal) {

                if (newVal) {
                    if (newVal > this.activeStep + 1) {
                        this.updateQuery({ step: this.activeStep });

                    } else {
                        this.$store.dispatch('setUserPaymentStep', parseInt(newVal, 10))

                    }

                    // Sync with URL step
                    if (this.activeStep === 2) {
                        this.getAllPaymentMethod()

                    }

                }
            }
        },
        '$route.query.payment': {
            immediate: true,
            handler(newVal) {
                if (newVal === "atom") {
                    if (this.payment.payment_step > 2 && this.payment.payment_type == 'atom' && this.payment.payment_plan_id) {
                        this.isAtomPayment = true;

                    } else {
                        this.$router.replace({ step: 1 })
                    }
                }
            }
        }

    },


    created() {
    },

    methods: {
        handleNext() {



            if (this.activeStep < 4) {

                this.$store.dispatch('setUserPaymentStep', this.activeStep + 1)

            } else {
                this.updateQuery({ atom: "pending" });

            }
            if (this.activeStep === 2) {
                let initialPayment = this.paymentOptions[0]
                this.selectPaymentType(0, initialPayment.name, initialPayment.is_auto_renewal, initialPayment.plans)
                 this.selectPaymentPlan(0, initialPayment.plans[0].label, this.checkCurrency()?initialPayment.plans[0].apple_price : initialPayment.plans[0].amount, initialPayment.plans[0].id)



            }



        },
        handleBack() {
            if (this.activeStep > 1) {
                this.$store.dispatch('setUserPaymentStep', this.activeStep - 1)
            }else if(this.activeStep === 1){
                this.$router.push('/')
            }


        },
        selectPaymentType(index, payment, renew, plan) {
            this.activePayment = index;
            this.$store.commit('SET_USER_PAYMENT_TYPE', payment)
            this.$store.commit('SET_USER_RENEW', renew)
            this.planOptions = plan
        },
        selectPaymentPlan(index, plan, amount, plan_id) {
            console.log('index', index, plan, amount, plan_id)
            this.selectedPlanOptions = index;
            this.$store.commit('SET_USER_PAYMENT_PLAN', {
                plan: plan,
                amount: amount,
                plan_id: plan_id
            });

        },
        updateQuery(newStep) {
            const newRoute = {
                path: this.$route.path,
                query: newStep
            };

            if (JSON.stringify(this.$route.query) !== JSON.stringify(newRoute.query)) {
                this.$router.replace(newRoute).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },

        /**
   * Subscribe
   */
        // subscribe_price_id: this.plan
        subscribeWithKpay() {


            axios.post('/api/v2/payment/kbzpay/create-order-web', { "item": { "id": this.payment.payment_plan_id, "type": "subscription" } }).then((response) => {
                // console.log(response);
                let resp = response.data.response.Response;
                let params = {
                    appid: "kp1c1bf4af979e4e1b835ca9bab89295",
                    merch_code: "70150001",
                    nonce_str: response.data.nonce_str,
                    prepay_id: resp.prepay_id,
                    qrCode: resp.qrCode,
                    timestamp: Math.floor(Date.now() / 1000),
                    sign: response.data.new_sign
                }

                this.$toast.success({ title: 'Success', message: response.data.message });
                this.$store.dispatch('setSubscribe', response.data);


                this.showKBZQR = true;
                this.qrCode = resp.qrCode;

                this.loading = false

            }).catch((error) => {
                this.$toast.warn({ title: 'Warning !!', message: error.response.data.message });
                this.$toasted.success(error.response.data.message, {
                    duration: 500
                })
                this.closeModal();
            });

        },
        subscribeWithCoins() {
            
            axios.post('/api/mmn/payment/coin', { subscription_id: this.payment.payment_plan_id }).then((response) => {
                this.$toast.success({ title: 'Success', message: response.data.message });
                this.$store.dispatch('setSubscribe', response.data);
                if(response.data.status === 200){
                this.isPaymentSuccess = true;
                    this.$toasted.success(response.data.message, {
                        duration: 800
                    })
                }else{
                    this.$toasted.error(response.data.message, {
                        duration: 800
                    })
                }
               
            }).catch((error) => {
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            });
        },
        subscribeWithMpt() {
            axios.post('/api/v2/payment/mpt/create-order-web', { "item": { "id": this.payment.payment_plan_id, "type": "subscription" } }).then((response) => {
                window.location.href = response.data.url;
            }).catch((error) => {
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
                this.$toast.warn({ title: 'Warning !!', message: error.response.data.message });
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
                this.closeModal();
            });
        },

        subscribeWithDingerCard(){
            axios.post('/api/mmn/payment/dinger/card/create-order',{"item":{
                "id":this.payment.payment_plan_id,
                "type":"subscription"
            }}).then((response)=>{
                window.location.href = response.data.prebuilt_url;
            }).catch((error)=>{
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            })

        },
        subscribeWithDingerOnline(){
            axios.post('/api/mmn/payment/dinger/online/create-order',{"item":{
                "id":this.payment.payment_plan_id,
                "type":"subscription"
            }}).then((response)=>{
                window.location.href = response.data.prebuilt_url;
            }).catch((error)=>{
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            })

        },

        subscribeWithApplePay(){
            axios.post('/api/mmn/payment/apple',{
                "receipt":this.appleReceipt
            }).then((response)=>{
                this.$store.dispatch('setSubscribe', response.data);
                if(response.data.status === 200){
                    this.isPaymentSuccess = true;
                    this.$toasted.success(response.data.message, {
                        duration: 800
                    })
                }else{
                    this.$toasted.error(response.data.message, {
                        duration: 800
                    })
                }
            }).catch((error)=>{
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            })
            
        },


        handleEnter: function (e, i) {
            const otpInputs = this.$refs.otpContainer.getElementsByTagName("*");
            const keyPressed = e.key
            const matched = keyPressed.match(/^[0-9]$/);
            if (i > 0 && (keyPressed === "Backspace" || keyPressed === "Delete")) {
                setTimeout(() => {
                    otpInputs[i - 1].focus();
                }, 50)
            } else if (i < this.inputsLength - 1 && matched) {
                setTimeout(() => {
                    otpInputs[i + 1].focus();
                }, 50)
            }
        },
        handlePayment: function () {
            console.log('this', this.payment.payment_type)
            switch (this.payment.payment_type) {
                case 'kbzpay':
                    this.showKBZQR = true;
                    this.subscribeWithKpay()
                    break;
                case 'coin':
                    this.subscribeWithCoins()
                    break;
                case 'mpt':
                    this.subscribeWithMpt()
                    break;
                case 'atom':
                    const newRoute = {
                        path: this.$route.path,
                        query: { payment: 'atom' }
                    };
                    this.$router.replace(newRoute);
                    break;
                case 'dinger_card':
                    this.subscribeWithDingerCard()
                    break;
                case 'dinger_online':
                    this.subscribeWithDingerOnline()
                    break;
                case 'applepay':
                    this.subscribeWithApplePay()
                    break;
            }
        },

     

        requestAtomOtp() {
            let phone = 9 + this.atomPhoneNumber;
            let userId = this.user.id
            const secretKey = 'vaRLfFj3bgP7TSKHzeXsZt8uMxh4cYQr';
            // Combine the data into a single string (you can change this format if necessary)
            const dataToHash = phone + userId;
            // Hash the combined data using SHA256
            const hashedData = CryptoJS.HmacSHA256(dataToHash, secretKey).toString(CryptoJS.enc.Hex);

            let arr = [...phone]
            this.phoneLastNumber = arr.slice(-3).join('')

           

            axios.post('/api/mmn/atom/payment/otp', {
                "phone_no": phone,
                "subscription_price_id": this.payment.payment_plan_id,
                "hash_value": hashedData
            }).then((response) => {
                
                this.$toasted.success("OTP Sent! Please check your phone!", {
                    duration: 800
                })
                this.showAtomOtpVerify = true;
                let resp = response.data.data;
                this.atomClientTransactionId = resp.clientTransactionId;



            }).catch((error) => {
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            });


        },
        verifyOpt() {


            const secretKey = 'vaRLfFj3bgP7TSKHzeXsZt8uMxh4cYQr';
            let userId = this.user.id
            // Combine the data into a single string (you can change this format if necessary)
            const dataToHash = this.atomClientTransactionId + userId;
            // Hash the combined data using SHA256
            const hashedData = CryptoJS.HmacSHA256(dataToHash, secretKey).toString(CryptoJS.enc.Hex);
            let otp = [...this.otpArr].join('');

                

            axios.post('/api/mmn/atom/payment/subscribe', {
                "transaction_id": this.atomClientTransactionId,
                "otp": otp,
                "hash_value": hashedData
            }).then((response) => {
                // console.log(response);
                let resp = response.data;
                // this.$toast.success({ title: 'Success', message: response.data.message });
                this.$store.dispatch('setSubscribe', response.data);


                this.atomPaymentPending = true;
                this.$refs.lottieAnimation.style.width = '200px';
                this.$refs.lottieAnimation.style.height = '300px';
                try {
                    lottie.loadAnimation({
                        container: this.$refs.lottieAnimation,
                        path: '/payment/noti_bell_lottie.json', // Ensure this path is correct
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                    });
                } catch (error) {
                    console.error('Error loading Lottie animation:', error);
                }


            }).catch((error) => {
                this.$toast.warn({ title: 'Warning !!', message: error.response.data.message });
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
                this.otpArr = []
            });


        },
        handleAtomPaymentBack() {

            if(this.atomPaymentPending) {
                this.startListening();
            this.atomPaymentPending = false;

            }

            this.otpArr = []
            this.$nextTick(() => {
                lottie.destroy();
                this.$refs.lottieAnimation.style.width = '0px';
                this.$refs.lottieAnimation.style.height = '0px';
                this.$refs.lottieAnimation.style.display = 'none';
            })
            if (this.showAtomOtpVerify) {
                this.showAtomOtpVerify = false;

            } else {
                const newRoute = {
                    path: this.$route.path,
                    query: { step: 3 }
                };
                this.$router.replace(newRoute);
            }

        },

        startListening() {
            this.$router.push('/')
        },

        getAllPaymentMethod() {
            axios.get('/api/mmn/payment/providers?type=subscription').then((response) => {
              
                this.$store.dispatch('setPaymentProviders', response.data.data);
                let initialPayment = this.paymentOptions[0]
                this.selectPaymentType(0, initialPayment.name, initialPayment.is_auto_renewal, initialPayment.plans)
                this.selectPaymentPlan(0, initialPayment.plans[0].label, this.checkCurrency()?initialPayment.plans[0].apple_price : initialPayment.plans[0].amount, initialPayment.plans[0].id)

            }).catch((error) => {
                
                this.isDisable = true;
                this.$toasted.error(error.response.data.message, {
                    duration: 800
                })
            });
        },

        
        checkCurrency() {
            // if(isCheckTwo){
            //     return this.payment.payment_type === 'apple_pay' || this.payment.payment_type === 'dinger_card'
            // }else{
            return this.payment.payment_type === 'applepay'

            // }

        },

        paymentNameTransformer(paymentType) {
            console.log('paymentType', paymentType)
            switch (paymentType) {
                case 'applepay':
                    return 'Apple Pay'
                case 'coin':
                    return 'Coin'
                case 'kbzpay':
                    return 'KBZPay'
                case 'mpt':
                    return 'MPT'
                case 'atom':
                    return 'ATOM'
                case 'dinger_card':
                    return 'Dinger Card'
                case 'dinger_online':
                    return 'Dinger Online'
            }
        }



    },
    beforeDestroy() {
        lottie.destroy();
    },
}
</script>

<template>
    <div class="premium-box-container">
        <div style="
        position: absolute;
        top:0;
        right: 0;
        ">
            <img src='/payment/bg-gradient-top-right.png' />

        </div>
        <div class="bg_gradient_top_left">
            <img src='/payment/bg-gradient-top-left.png' />
        </div>
        <div class="bg_gradient_bottom_left">
            <img src='/payment/bg-gradient-bottom-left.png' />
        </div>
        <div class="bg_gradient_bottom_right">
            <img src='/payment/bg-gradient-bottom-right.png' />
        </div>
        <div v-if="isAtomPayment" class="atom_payment">
            <div class="box-title">
                <div @click="() => {
                    handleAtomPaymentBack()
                }" class="back-btn">

                    <svg xmlns="http://www.w3.org/2000/svg" height="14" width="12.25" viewBox="0 0 448 512">
                        <path fill="#ffffff"
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                    </svg>


                    <span>Back</span>
                </div>
                <h5 style="color:white ; margin-left: -3rem">ATOM Payment</h5>
                <div>
                </div>
            </div>

            <div class="atom_payment_container">

                <div v-if="!showAtomOtpVerify">
                    <div style="margin: 2rem 0 ; display: flex;justify-content: center;">
                        <img src="/payment/atomLogo.png" alt="atom logo" />
                    </div>
                    <Form class="atom_payment_descriptions" @submit.prevent="requestAtomOtp">
                        <span style="color:white">Enter your ATOM Phone Number. Verification code will be sent to
                            you.</span>
                        <span style="color:#13D1FF;display:flex;align-items:center;gap:0.5rem"> <img
                                src="/payment/info.svg" alt="info" /><span>Only ATOM phone number is
                                allowed.</span></span>
                        <div class="atom_payment_phone_number_input-box">
                            <label>Enter Phone Number</label>
                            <div>
                                <span class="prefix">09</span>
                                <input type="number" v-model="atomPhoneNumber" placeholder="XXXXXXXX" />
                            </div>

                        </div>
                        <div class="next-btn-container">
                            <button type="submit" class="next-button">Continue</button>
                        </div>
                    </Form>
                </div>



                <div v-else-if="!atomPaymentPending">
                    <div class="opt_info">
                        <h5 style="color:white">6 Digit Codes</h5>
                        <span>Please enter the code that we sent to 09 XXXXX{{ phoneLastNumber }}</span>
                    </div>

                    <div>

                        <form method="POST" @submit.prevent="verifyOpt">
                            <div class="form-group otp_input_wrapper" ref="otpContainer">
                                <input @keyup="(e) => handleEnter(e, 0)" type="text" v-model="otpArr[0]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">

                                <input @keyup="(e) => handleEnter(e, 1)" type="text" v-model="otpArr[1]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">

                                <input @keyup="(e) => handleEnter(e, 2)" type="text" v-model="otpArr[2]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">

                                <input @keyup="(e) => handleEnter(e, 3)" type="text" v-model="otpArr[3]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">
                                <input @keyup="(e) => handleEnter(e, 4)" type="text" v-model="otpArr[4]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">
                                <input @keyup="(e) => handleEnter(e, 5)" type="text" v-model="otpArr[5]"
                                    v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                                    :class="hasError('phone')">


                            </div>
                            <div class="next-btn-container">
                                <button type="submit" class="next-button">Continue</button>
                            </div>

                        </form>


                    </div>
                </div>
                <div ref="lottieAnimation"></div>
                <div class="atom_payment_pending" v-if="atomPaymentPending">
                    <span>Your request for Melo Premium is a success. Please wait while we process your payment. While
                        you wait, you can explore Melo.</span>
                    <h1 class="congratulation">Paid with ATOM</h1>

                </div>


            </div>
        </div>
        <div class="premium-box" v-else-if="showKBZQR">
            <span @click="() => {
                this.$router.push('/')
            }" data-v-7356b5eb="" data-dismiss="modal" class="close"
                style="font-size: 30px;font-weight: 100px">×</span>
            <div class="qr_payment">

                <h4>QR Payment</h4>
                <br>

                <h5>Please open KBZPay Application and Scan this QR Code to complete payment</h5>
                <div class="" style="margin-bottom:10px">
                    <img id='qrcode' :src="qrValue" alt="" title="HELLO" width="200" height="200" />
                </div>
                <h5>After payment, you can close and refresh the page.</h5>
            </div>
        </div>
        <div v-else-if="isPaymentSuccess" class="success_box">
            <span @click="() => {
                this.$router.push('/')
            }" data-v-7356b5eb="" data-dismiss="modal" class="close"
                style="font-size: 30px;font-weight: 100px">×</span>
            <div class="success">
                <img src='/payment/success.svg' alt="success" />
                <h3 class="congratulation">Congratulations!</h3>
                <span>
                    You have subscribed to Melo’s Premium.
                </span>
                <span>
                    Enjoy the Premium Features.
                </span>
                <button @click="startListening" class="next-button">Start Listening</button>
            </div>
        </div>

        <div v-else class="premium-box">
            <div class="box-title">
                <div @click="() => {
                    handleBack()
                }" class="back-btn">

                    <svg xmlns="http://www.w3.org/2000/svg" height="14" width="12.25" viewBox="0 0 448 512">
                        <path fill="#ffffff"
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                    </svg>


                    <span>Back</span>
                </div>
                <h5 style="color:white">Upgrade to premium</h5>
                <div>
                </div>
            </div>
            <div class="payment-step">
                <div class="stepper">
                    <div class="step  " :class="{
                        'active': this.activeStep == 1,
                        'complete': this.activeStep > 1

                    }">
                        <div class="circle">
                            <img v-if="this.activeStep > 1" src='/benefits/mark.svg' alt="mark" />

                            <div v-else class="inside-circle "></div>
                        </div>
                        <div class="label " :class="this.activeStep == 1 ? 'active' : ''">Premium Benefits</div>
                    </div>
                    <div class="step" :class="{
                        'active': this.activeStep == 2,
                        'complete': this.activeStep > 2

                    }">
                        <div class="circle">
                            <img v-if="this.activeStep > 2" src='/benefits/mark.svg' alt="mark" />
                            <div v-else class="inside-circle "></div>
                        </div>
                        <div class="label" :class="this.activeStep == 2 ? 'active' : ''">Choose Plan</div>
                    </div>
                    <div class="step" :class="this.activeStep == 3 ? 'active' : ''">
                        <div class="circle">
                            <img v-if="this.activeStep > 3" src='/benefits/mark.svg' alt="mark" />

                            <div v-else class="inside-circle "></div>
                        </div>
                        <div class="label" :class="this.activeStep == 3 ? 'active' : ''">Checkout</div>
                    </div>
                </div>


            </div>
            <div v-if="this.activeStep == 1" class="benefit-content-container">
                <div>
                    <img src="/img/music.svg" alt="music" width="180px" height="180px" />

                </div>
                <h4 style="color:white">Subscribe Premium</h4>
                <span style="color:#D3D3D3 ;margin-right: 80px;">You will get the available service such as;</span>
                <div class="benefits-container" v-for="(benefit, index) in premiumBenefits" :key="index">
                    <div>
                        <img :src="benefit.image" alt="benefit" />
                        <span style="color: white">{{ benefit.title }}</span>
                    </div>
                    <div>
                        <img src="/benefits/mark-circle.svg" alt="circle" />
                    </div>

                </div>
            </div>
            <div v-else-if="this.activeStep == 2" class="payment-plan-container">
                <div class="payment-options-container">
                    <div style="color:white">Payment Options</div>
                    <div @click="() => selectPaymentType(index, option.name, option.is_auto_renewal, option.plans)"
                        class="payment-option" v-for="(option, index) in paymentOptions.filter(option=>option.name !== 'applepay')" :key="index"
                        :class="index === activePayment ? 'active' : ''">
                        <div class="plan-image">
                            <img :src="paymentImageByName(option.name)" alt="plan-image" width="30px" height="25px" />
                        </div>
                        <div>
                            <div class="plan-name" :class="index === activePayment ? 'active' : ''">{{ option.label
                                }}
                                <span v-if="option.is_auto_renewal" class='auto_renew'>
                                    ( Auto Renewal )
                                </span>
                            </div>
                            <div class="plan-description">{{ option.description }}</div>

                        </div>
                    </div>
                </div>
                <div class="plan-options">
                    <div style="color:white">Plan Options</div>
                    <div class="plan-option" v-for="(plan, index) in planOptions" :key="index"
                        @click="() => selectPaymentPlan(index, plan.label, checkCurrency()?plan.apple_price : plan.amount, plan.id)"
                        :class="index === selectedPlanOptions ? 'active' : ''">
                        <div>
                            <div class="radio-btn" :class="selectedPlanOptions === index ? 'active' : ''">
                                <div v-if="selectedPlanOptions === index" class="radio-active"></div>
                            </div>
                            <span class="label" :class="selectedPlanOptions === index ? 'active' : ''">{{ plan.label
                                }}</span>
                        </div>
                        <div class="auto_renew">
                            <span v-if="checkCurrency()">$</span>
                            {{ checkCurrency() ? plan.apple_price : plan.amount }}
                            <span v-if="!checkCurrency()">Ks</span>


                        </div>
                    </div>
                    <div style="color:white">
                        By continuing, you agree <span style="color:#FF2150">to the Terms of Service and Privacy
                            Policy.</span>
                    </div>
                </div>
            </div>
            <div v-else-if="activeStep === 3" class='checkout-container'>

                <img src="/payment/Checkout.svg" alt="checkout" />
                <div class="payment-info">
                    <div>
                        <span>Type</span>
                        <span style="color:white">Premium</span>
                    </div>

                    <div>
                        <span>Payment Method</span>
                        <span style="color:white">{{paymentNameTransformer(payment.payment_type)}}&nbsp;<span
                                v-if="payment.payment_type !== 'Wallet Payment'">Payment</span></span>
                    </div>
                    <div>
                        <span>Subscription</span>
                        <span style="color:white">{{ payment.payment_renew ? 'Auto Renewal' : '' }}</span>
                    </div>
                    <div>
                        <span>Plan</span>
                        <span style="color:white">{{ payment.payment_plan }}</span>
                    </div>
                    <div class="dot-dash"></div>
                    <div>
                        <span>Type</span>
                        <span class="auto_renew" style="display: flex;justify-content: flex-end">{{
                            payment.payment_amount }} {{checkCurrency() ? '$' : 'Ks'}}</span>
                    </div>
                </div>
            </div>
            <div v-else-if="choicePaymentType == 'atom'">
                <h2 class="otp_title">OTP Verification</h2>
                <p class="otp_info otp_info_upper">Please enter the code that we sent to {{ this.phone }}</p>
                <form method="POST" @submit.prevent="">
                    <div v-if="operator.type === 'mpt'" class="form-group otp_input_wrapper" ref="otpContainer">
                        <input @keyup="(e) => handleEnter(e, 0)" type="text" v-model="otpArr[0]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 1)" type="text" v-model="otpArr[1]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 2)" type="text" v-model="otpArr[2]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 3)" type="text" v-model="otpArr[3]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">
                    </div>
                    <div v-else class="form-group otp_input_wrapper" ref="otpContainer">
                        <input @keyup="(e) => handleEnter(e, 0)" type="text" v-model="otpArr[0]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 1)" type="text" v-model="otpArr[1]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 2)" type="text" v-model="otpArr[2]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 3)" type="text" v-model="otpArr[3]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 4)" type="text" v-model="otpArr[4]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">

                        <input @keyup="(e) => handleEnter(e, 5)" type="text" v-model="otpArr[5]"
                            v-validate="'required|number'" name="otp" placeholder="" maxlength="1"
                            :class="hasError('phone')">
                    </div>
                </form>


            </div>
            <div class="next-btn-container">
                <button @click="() => {
                    if (!isDisable) {
                        payment.payment_step === 3 ? handlePayment() : handleNext()

                    }

                }" class="next-button" :class="isDisable ? 'disable' : ''">{{ payment.payment_step === 3 ? 'Confirm' :
                    'Next' }}</button>

            </div>
        </div>




    </div>
</template>
<style scoped>
.premium-box-container {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100vw;
    margin: 0;
    padding: 0;
    height: 100vh;
}

.bg_gradient_top_left {
    position: absolute;
    top: 0;
    left: 0;
}

.bg_gradient_bottom_left {
    position: absolute;
    bottom: 0;
    left: 0;
}

.bg_gradient_bottom_right {
    position: absolute;
    bottom: 0;
    right: 0;
}

.congratulation {
    background: linear-gradient(to right, #FF512F, #DD2476);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.success_box {
    background: #353037;
    position: fixed;
    width: 450px;
    height: 450px;
    background-image: url('/payment/success_bg.svg');
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
}

.success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1rem;

}

.premium-box,
.atom_payment {
    background: #353037;
    position: fixed;
    width: 45vw;
    border-radius: 10px;
    padding: 25px;
    min-height: 30rem;
}

.premium-box .box-title,
.atom_payment .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
}

.benefit-content-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 2px
}

.disable {
    cursor: not-allowed;
}

.dot-dash {

    border: 1.5px dashed #D3D3D3;
}

.back-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}

.back-btn h5 {
    margin-bottom: 0;
}

.benefits-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 20rem;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.benefits-container>div:first-child {
    display: flex;
    gap: 10px;
    align-items: center;
}

.next-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
}

.next-button {
    background: #FF2150;
    color: white;
    width: 10rem;
    border-radius: 32px;
    border: none;
    padding: 0.6rem 0.3rem;
    margin-top: 0.5rem;
}

.stepper {
    display: flex;
    justify-content: space-between;
    max-width: 600px;
    margin: 30px auto;
}

.step {
    text-align: center;
    flex: 1;
    position: relative;
}

.step:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 20%;
    right: -50%;
    width: 100%;
    height: 3px;
    background-color: #ccc;
    z-index: -1;
    transform: translateY(-50%);
}

.circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    margin: 0 auto;
    font-size: 18px;
    line-height: 40px;
    font-weight: bold;
}

.label {

    font-size: 14px;
    color: #898F8F;
}

.label.active {
    color: #FF2150;
    font-weight: bold;
}

.step.active .circle {
    background-color: #FF2150;

}

.step.complete .circle {
    background-color: #FF2150;

}



.step .circle .inside-circle {
    background-color: #E0E0E7;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.step.active .circle .inside-circle.active {
    background-color: white;
}

.step.active+.step .circle {
    background-color: #ccc;
}

.step.active~.step .circle {
    background-color: #eee;
}

.step.active~.step::after {
    background-color: #eee;
}

.payment-plan-container {
    display: flex;
    gap: 0.5rem
}

.payment-options-container {
    display: flex;
    flex-direction: column;
    flex: 1.5;
    gap: 0.4rem;

}

.payment-option {
    display: flex;
    gap: 10px;
    padding: 18px 19px;
    border: 1px solid #575757;
    align-items: center;
    height: 60px;
    border-radius: 0.5rem;
    background-color: #27282E;
    cursor: pointer;

}

.payment-option.active {
    border: 2px solid #FF2150;
    box-shadow: #FF2150 0px 1.5px 7px;

}

.plan-name {
    color: white;
    gap: 0.5rem;

}

.plan-name.active {
    color: #FF2150
}

.plan-description {
    font-size: 12px;
    color: #D3D3D3
}

.plan-options {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.4rem
}

.plan-option .label {
    color: white
}

.plan-option .label.active {
    color: #FF2150
}

.plan-option {
    display: flex;
    padding: 18px 19px;
    justify-content: space-between;
    border: 1px solid #575757;
    align-items: center;
    height: 60px;
    border-radius: 0.5rem;
    background-color: #27282E;
    cursor: pointer;
}

.plan-option.active {
    border: 2px solid #FF2150;
    box-shadow: #FF2150 0px 1.5px 7px;
}

.radio-btn {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #919191;
    display: flex;
    justify-content: center;
    align-items: center;
}

.radio-btn.active {
    border: 1px solid #FF2150
}

.radio-active {
    background: #FF2150;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.plan-option>div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.plan-option>div>span {
    margin-top: 0.1rem;
}

.checkout-container {
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    align-items: center;
    gap: 3rem;
}

.payment-info {
    padding: 20px 24px;
    min-width: 20rem;
    background: #27282E;
    border-radius: 0.5rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 0.7rem;

}

.payment-info>div {
    display: flex;
    justify-content: space-between;
    gap: 1rem
}

.payment-info>div>span:first-child {
    flex: 2
}

.payment-info>div>span:last-child {
    text-align: end;
    flex: 1.5
}

.atom_payment_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}

.atom_payment_descriptions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.atom_payment_phone_number_input-box {
    display: flex;
    flex-direction: column;

}

.atom_payment_phone_number_input-box div {
    background: #27282E;
    padding: 18px 17px;
    border: none;
    display: flex;
    align-items: center;

}

.atom_payment_phone_number_input-box div>.prefix {
    color: white
}

.atom_payment_phone_number_input-box div input {
    background: transparent;
    color: white;
    border: none;
    width: 100%
}

.atom_payment_phone_number_input-box div input:focus {
    outline: none;
}

.opt_info {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: 3rem 0 1rem 0;
}

.otp_input_wrapper {
    width: 100%;
    display: flex;
    /* justify-content: center; */
    gap: 0.5rem;
    flex-wrap: wrap;
}

.otp_input_wrapper input {
    color: #FFF;
    background-color: #27282E;
    width: 4rem;
    max-width: 90px;
    height: 4rem;
    border: 1px solid #FFF;
    border-radius: 0.5rem;
    text-align: center;
    border: none;
    outline: none;
}

.otp_input_wrapper input:focus {
    border: 1px solid #FF2150;
    color: #FF2150
}

.auto_renew {
    color: #13D1FF;
    margin-left: 0.5rem
}

.qr_payment {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: white
}

.atom_payment_pending {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    width: 400px !important;
    text-align: center;

}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
    /* For Firefox */
}

.is-invalid {
    border: none!important;
    background-position: center !important;
}


@media (max-width: 1800px) and (min-width: 770px) {

    .premium-box,
    .atom_payment {
        width: 60vw
    }

    .payment-option {
        gap: 5px;
        padding: 10px;
        height: 60px;
    }

    .payment-option .plan-name {
        font-size: 12px;
    }

    /* .plan-description {
        display: none
    } */

    .plan-option {
        height: 60px;
        font-size: 12px;
        padding: 10px;

    }

    .plan-option>div {
        gap: 5px
    }

    .auto_renew {
        margin-left: 0.2rem;
    }
}

/* for tablet and mobile normal screen */
@media (max-width: 950px) {

    .premium-box,
    .atom_payment {
        width: 90vw
    }

    .payment-option {
        gap: 5px;
        padding: 10px;
        height: 60px;
    }

    .payment-option .plan-name {
        font-size: 12px;
    }

    .plan-description {
        display: none
    }

    .plan-option {
        height: 60px;
        font-size: 12px;
        padding: 10px;

    }

    .plan-option>div {
        gap: 5px
    }

    .auto_renew {
        margin-left: 0.2rem;
        display: flex;
        align-items: center;
    }

    .atom_payment_pending {
        width: 300px !important;
    }

    .otp_input_wrapper input {
        color: #FFF;
        background-color: #27282E;
        width: 3.3rem;
        max-width: 100px;
        height: 3.3rem;
        border: 1px solid #FFF;
        border-radius: 0.5rem;
        text-align: center;
        border: none;
        outline: none;
    }
}

/* for small mobile  screen */
@media(max-width: 380px) {

    .premium-box,
    .atom_payment {
        width: 95vw
    }

    .stepper {
        margin: 15px 0;
    }

    .bg_gradient_top_left {
        display: none;
    }

    .bg_gradient_bottom_left {
        display: none;
    }
}
</style>
